module.exports = __webpack_public_path__ + "static/media/show-gal-4.0102def6.jpg";